import { validateEmail } from "../utils/helpers";

const Newsletter = (element) => {
  const button = element.querySelector("button[type='submit']");
  const completionOverlay = element.querySelector(".formComplete");
  const hideableContent = element.querySelector(".formHideable");

  const statusText = element.querySelector("#newsletter-status");
  const inputEmail = element.querySelector("#newsletter-email");
  const inputEmailParent = inputEmail.parentNode;

  const disableForm = () => {
    element.classList.add("disabled");

    if (inputEmail) {
      inputEmail.classList.add("disabled");
      inputEmail.disabled = true;
    }

    if (button) {
      button.classList.add("disabled");
      button.disabled = true;
    }
  };

  const enableForm = () => {
    element.classList.remove("disabled");

    if (inputEmail) {
      inputEmail.classList.remove("disabled");
      inputEmail.disabled = false;
      inputEmail.value = "";
    }

    if (button) {
      button.classList.remove("disabled");
      button.disabled = false;
    }

    if (completionOverlay) {
      completionOverlay.classList.remove("active");
    }

    if (hideableContent) {
      hideableContent.classList.remove("masked");
    }
  };

  const validate = () => {
    let valid = true;

    if (
      !inputEmail ||
      inputEmail.value.trim() === "" ||
      !validateEmail(inputEmail.value)
    ) {
      valid = false;
      statusText.classList.add("active");
    } else {
      statusText.classList.remove("active");
    }

    return valid;
  };

  const addOnChangeListeners = () => {
    if (inputEmail) {
      inputEmail.addEventListener("input", (e) => {
        inputEmailParent.classList.remove("error");
      });
    }
  };

  const addSubmitListener = () => {
    element.addEventListener("submit", (e) => {
      e.preventDefault();

      if (!validate()) {
        return;
      }

      disableForm();

      if (!completionOverlay) {
        console.error("Render issue: no completion overlay");
      }

      const formData = new FormData(element);
      const url = "/wp-admin/admin-ajax.php";
      formData.append("newsletter_email", inputEmail.value);

      setTimeout(() => {
        completionOverlay.classList.add("active");
        hideableContent.classList.add("masked");
      }, 1000);

      console.log("sending to Mailchimp");

      fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) =>
          response.json().then((data) => {
            console.log("Result:", data);
          })
        )
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          setTimeout(() => {
            enableForm();
          }, 10000);
        });
    });
  };

  const main = () => {
    addOnChangeListeners();
    addSubmitListener();
  };

  main();
};

export default Newsletter;
